module.exports = __webpack_public_path__ + "static/img/vrroad_img3.52e089d9.png";